// extracted by mini-css-extract-plugin
module.exports = {"active":"RadioButton_active__TTuK6","inactive":"RadioButton_inactive__Aw7wB"};